import { useMemo, useState } from 'react'
import { contacts, isDnd } from '../state/roster'
import { useSnapshot } from '../state/TelephonyProvider'
import { useDial } from '../state/useDial'
import { type ExtensionState } from '../contract'
import { IconPhone, IconPhoneOutgoing } from '../ui/icons'
import { dotColor } from './blf'

export function ContactsPanel() {
  const { extensions } = useSnapshot()
  const dial = useDial()
  const [q, setQ] = useState('')

  const stateByExt = useMemo(() => {
    const m = new Map<string, ExtensionState>()
    for (const e of extensions) m.set(e.ext, e.state)
    return m
  }, [extensions])

  const rows = useMemo(() => {
    const n = q.trim().toLowerCase()
    return n
      ? contacts.filter((c) =>
          c.name.toLowerCase().includes(n) || (c.ext ?? '').includes(n) || (c.number ?? '').includes(n))
      : contacts
  }, [q])

  return (
    <div className="sb-panel">
      <input className="search" placeholder="Search contacts…" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Search contacts" />
      {rows.map((c, i) => {
        const dest = c.ext ?? c.number ?? ''
        const st = c.ext ? stateByExt.get(c.ext) : undefined
        const ringing = st === 'ringing'
        return (
          <div key={`${dest}-${i}`} className="list-row row">
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 9, minWidth: 0 }}>
              {c.ext ? (
                <span
                  className={ringing ? 'blf-dot blf-dot-ring' : 'blf-dot'}
                  style={ringing ? undefined : { background: dotColor(st ?? 'unknown', isDnd(c.ext)) }}
                  title={st ?? 'unknown'}
                />
              ) : (
                <span className="blf-dot blf-dot-ext" title="external number">
                  <IconPhoneOutgoing size={11} stroke={2} />
                </span>
              )}
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <strong>{c.name}</strong> <span className="faint">· {c.ext ?? c.number}</span>
              </span>
            </span>
            <button className="btn" onClick={() => dial(dest)} aria-label={`Call ${c.name}`}>
              <IconPhone size={14} stroke={1.75} /> call
            </button>
          </div>
        )
      })}
    </div>
  )
}
